// extracted by mini-css-extract-plugin
export default {"oauthBtn":"styles_oauthBtn__xL3a9","spinner":"styles_spinner__OaXQ5"};